import { Link } from "react-router-dom";
import React from 'react';
import OwlCarousel from 'react-owl-carousel';  
export default function HomeTwoPortfolio(){
    return(
        <>
        <section id="projects" className="case-study-area pt-120 pb-120 pt-md-60 pt-xs-60">
            <div className="container">
                <div className="row justify-content-center">
                    <div className=" col-lg-8">
                        <div className="services-title2 text-center mb-55">
                            <h2 className="style-text">Works</h2>
                            <h6 className="semi-title semi-title2 pl-0">Our Works</h6>
                            <h2 className="sect-title">Company case study</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid px-0">            
                <OwlCarousel items={4}  
                className="owl-theme cases-slide"  
                loop 
                dots={false}			  
                margin={30} 
                responsive= {
                    {
                        '1':{
                            items: 1
                        },
                        '768': {
                            items: 2
                        },
    
                        '1200': {
                            items: 4
                        }
    
                    }
                    
                }
                >
                    <div className="item">
                        <div className="single-cases-wrapper">
                            <div className="cases-thumb">
                                <Link to="/case-details"><img className="img-fluid" src="assets/img/case/case-1.jpg"
                                        alt="Case Img" /></Link>
                            </div>
                            <div className="single-case">
                                <h6 className="fs-14 text-theme2 fw-normal">UI & UX, IT Solution</h6>
                                <h4 className="sub-title text-heding2"><Link to="/case-details">Smartrics Web
                                        Solution</Link></h4>
                                <p className="fs-14">Lorem ipsum dolor sit amet, consectetur a
                                    dipisicing elit, sed do eiusmod.</p>
                                <div className="case-info">
                                    <span><b>Client:</b> Amrilox Co.</span>
                                    <span><b>Duration:</b> 2 Month</span>
                                    <span><b>Budget:</b> $50k</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="item">
                        <div className="single-cases-wrapper">
                            <div className="cases-thumb">
                                <Link to="/case-details"><img className="img-fluid" src="assets/img/case/case-2.jpg"
                                        alt="Case Img" /></Link>
                            </div>
                            <div className="single-case">
                                <h6 className="fs-14 text-theme2 fw-normal">UI & UX, IT Solution</h6>
                                <h4 className="sub-title text-heding2"><Link to="/case-details">Smartrics Web
                                        Solution</Link></h4>
                                <p className="fs-14">Lorem ipsum dolor sit amet, consectetur a
                                    dipisicing elit, sed do eiusmod.</p>
                                <div className="case-info">
                                    <span><b>Client:</b> Amrilox Co.</span>
                                    <span><b>Duration:</b> 2 Month</span>
                                    <span><b>Budget:</b> $50k</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="item">
                        <div className="single-cases-wrapper">
                            <div className="cases-thumb">
                                <Link to="/case-details"><img className="img-fluid" src="assets/img/case/case-3.jpg"
                                        alt="Case Img" /></Link>
                            </div>
                            <div className="single-case">
                                <h6 className="fs-14 text-theme2 fw-normal">UI & UX, IT Solution</h6>
                                <h4 className="sub-title text-heding2"><Link to="/case-details">Smartrics Web
                                        Solution</Link></h4>
                                <p className="fs-14">Lorem ipsum dolor sit amet, consectetur a
                                    dipisicing elit, sed do eiusmod.</p>
                                <div className="case-info">
                                    <span><b>Client:</b> Amrilox Co.</span>
                                    <span><b>Duration:</b> 2 Month</span>
                                    <span><b>Budget:</b> $50k</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="item">
                        <div className="single-cases-wrapper">
                            <div className="cases-thumb">
                                <Link to="/case-details"><img className="img-fluid" src="assets/img/case/case-1.jpg"
                                        alt="Case Img" /></Link>
                            </div>
                            <div className="single-case">
                                <h6 className="fs-14 text-theme2 fw-normal">UI & UX, IT Solution</h6>
                                <h4 className="sub-title text-heding2"><Link to="/case-details">Smartrics Web
                                        Solution</Link></h4>
                                <p className="fs-14">Lorem ipsum dolor sit amet, consectetur a
                                    dipisicing elit, sed do eiusmod.</p>
                                <div className="case-info">
                                    <span><b>Client:</b> Amrilox Co.</span>
                                    <span><b>Duration:</b> 2 Month</span>
                                    <span><b>Budget:</b> $50k</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="item">
                        <div className="single-cases-wrapper">
                            <div className="cases-thumb">
                                <Link to="/case-details"><img className="img-fluid" src="assets/img/case/case-2.jpg"
                                        alt="Case Img" /></Link>
                            </div>
                            <div className="single-case">
                                <h6 className="fs-14 text-theme2 fw-normal">UI & UX, IT Solution</h6>
                                <h4 className="sub-title text-heding2"><Link to="/case-details">Smartrics Web
                                        Solution</Link></h4>
                                <p className="fs-14">Lorem ipsum dolor sit amet, consectetur a
                                    dipisicing elit, sed do eiusmod.</p>
                                <div className="case-info">
                                    <span><b>Client:</b> Amrilox Co.</span>
                                    <span><b>Duration:</b> 2 Month</span>
                                    <span><b>Budget:</b> $50k</span>
                                </div>
                            </div>

                        </div>
                    </div>				
                    <div className="item">
                        <div className="single-cases-wrapper">
                            <div className="cases-thumb">
                                <Link to="/case-details"><img className="img-fluid" src="assets/img/case/case-3.jpg"
                                        alt="Case Img" /></Link>
                            </div>
                            <div className="single-case">
                                <h6 className="fs-14 text-theme2 fw-normal">UI & UX, IT Solution</h6>
                                <h4 className="sub-title text-heding2"><Link to="/case-details">Smartrics Web
                                        Solution</Link></h4>
                                <p className="fs-14">Lorem ipsum dolor sit amet, consectetur a
                                    dipisicing elit, sed do eiusmod.</p>
                                <div className="case-info">
                                    <span><b>Client:</b> Amrilox Co.</span>
                                    <span><b>Duration:</b> 2 Month</span>
                                    <span><b>Budget:</b> $50k</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </OwlCarousel>           
            </div>
	    </section>
        </>
    )    
}